var _defs, _rect, _rect2, _rect3, _rect4, _polygon, _path, _path2, _rect5, _polygon2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaveganteDigital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 156.9 156.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#Degradado_sin_nombre_2-8);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#Degradado_sin_nombre_2-4);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#Degradado_sin_nombre_2-5);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#Degradado_sin_nombre_6-2);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#Degradado_sin_nombre_6);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#Degradado_sin_nombre_2-6);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#Degradado_sin_nombre_20-2);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#Degradado_sin_nombre_2-3);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#Degradado_sin_nombre_6-6);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#Degradado_sin_nombre_2);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#Degradado_sin_nombre_20);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: url(#Degradado_sin_nombre_2-7);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#Degradado_sin_nombre_6-3);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#Degradado_sin_nombre_2-9);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#Degradado_sin_nombre_6-4);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: url(#Degradado_sin_nombre_2-2);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#Degradado_sin_nombre_6-5);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6",
    "data-name": "Degradado sin nombre 6",
    x1: 80.04,
    y1: 121.49,
    x2: 81.23,
    y2: 121.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d1669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7251b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-2",
    "data-name": "Degradado sin nombre 6",
    x1: 261.14,
    y1: 5.05,
    x2: 262.33,
    y2: 5.05,
    gradientTransform: "translate(55.13 -146.93) rotate(90)",
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-3",
    "data-name": "Degradado sin nombre 6",
    x1: -412.6,
    y1: -220.33,
    x2: -411.41,
    y2: -220.33,
    gradientTransform: "translate(296.43 -360.03) rotate(-90)",
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-4",
    "data-name": "Degradado sin nombre 6",
    x1: 113.22,
    y1: 117.08,
    x2: 119.32,
    y2: 117.08,
    gradientTransform: "translate(50.67 -34.33) rotate(21.38)",
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-5",
    "data-name": "Degradado sin nombre 6",
    x1: 26.32,
    y1: 129.85,
    x2: 129.75,
    y2: 129.85,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20",
    "data-name": "Degradado sin nombre 20",
    x1: 78.6,
    y1: 71.77,
    x2: 119.84,
    y2: 71.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bccce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bccce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d2d9f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e0e2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-2",
    "data-name": "Degradado sin nombre 20",
    x1: 41.62,
    y1: 79.61,
    x2: 71.57,
    y2: 79.61,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-6",
    "data-name": "Degradado sin nombre 6",
    x1: 73.89,
    y1: 68.1,
    x2: 75.34,
    y2: 68.1,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    "data-name": "Degradado sin nombre 2",
    x1: 75.34,
    y1: 23.13,
    x2: 90.04,
    y2: 23.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f90b2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e55566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-2",
    "data-name": "Degradado sin nombre 2",
    x1: 78.67,
    y1: 104.41,
    x2: 119.53,
    y2: 104.41,
    xlinkHref: "#Degradado_sin_nombre_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-3",
    "data-name": "Degradado sin nombre 2",
    x1: 78.67,
    y1: 83.6,
    x2: 116.27,
    y2: 83.6,
    xlinkHref: "#Degradado_sin_nombre_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-4",
    "data-name": "Degradado sin nombre 2",
    x1: 78.67,
    y1: 62.8,
    x2: 108.86,
    y2: 62.8,
    xlinkHref: "#Degradado_sin_nombre_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-5",
    "data-name": "Degradado sin nombre 2",
    x1: 78.67,
    y1: 41.99,
    x2: 95.89,
    y2: 41.99,
    xlinkHref: "#Degradado_sin_nombre_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-6",
    "data-name": "Degradado sin nombre 2",
    x1: 42.29,
    y1: 101.95,
    x2: 71.56,
    y2: 101.95,
    xlinkHref: "#Degradado_sin_nombre_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-7",
    "data-name": "Degradado sin nombre 2",
    x1: 45.81,
    y1: 87.05,
    x2: 71.56,
    y2: 87.05,
    xlinkHref: "#Degradado_sin_nombre_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-8",
    "data-name": "Degradado sin nombre 2",
    x1: 51.96,
    y1: 72.16,
    x2: 71.56,
    y2: 72.16,
    xlinkHref: "#Degradado_sin_nombre_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-9",
    "data-name": "Degradado sin nombre 2",
    x1: 60.5,
    y1: 57.27,
    x2: 71.56,
    y2: 57.27,
    xlinkHref: "#Degradado_sin_nombre_2"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 80.04,
    y: 114.07,
    width: 1.19,
    height: 14.83
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 42.67,
    y: 114.2,
    width: 14.83,
    height: 1.19,
    transform: "translate(-74.25 99.69) rotate(-59.5)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 68.68,
    y: 51.39,
    width: 14.83,
    height: 1.19
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 115.85,
    y: 109.8,
    width: 0.85,
    height: 14.55,
    transform: "translate(-34.68 50.44) rotate(-21.38)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "129.75 119.76 26.32 119.76 41.77 139.94 114.31 139.94 129.75 119.76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m119.84,114.49h-41.24V29.06s41.24,26.21,41.24,85.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m71.57,114.07V45.14s-29.94,33.47-29.94,68.93h29.94Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 73.89,
    y: 16.43,
    width: 1.44,
    height: 103.33
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "75.34 18.8 75.34 27.47 90.04 23.13 75.34 18.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m119.53,108.25h-40.86v-7.68h40.09c.33,2.49.59,5.05.76,7.68Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m116.27,87.44h-37.6v-7.68h35.42c.8,2.47,1.54,5.03,2.18,7.68Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m108.86,66.64h-30.19v-7.68h26.16c1.39,2.4,2.74,4.96,4.03,7.68Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m95.89,45.83h-17.22v-7.68h10.44c2.1,2.16,4.41,4.72,6.78,7.68Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m71.56,99.2v5.49h-29.27c.25-1.85.58-3.68.97-5.49h28.31Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m71.56,84.3v5.49h-25.75c.61-1.86,1.28-3.7,1.99-5.49h23.76Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.56,69.42v5.49h-19.6c.94-1.9,1.9-3.73,2.87-5.49h16.73Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m71.56,54.52v5.49h-11.07c1.3-2.01,2.56-3.84,3.75-5.49h7.32Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaveganteDigital);
export default __webpack_public_path__ + "static/media/navegante-digital.9be30e93d4acbb2379ce6864381cc92a.svg";
export { ForwardRef as ReactComponent };